import { render, staticRenderFns } from "./ObraPageView.vue?vue&type=template&id=69ccd318&scoped=true"
import script from "./ObraPageView.vue?vue&type=script&lang=js"
export * from "./ObraPageView.vue?vue&type=script&lang=js"
import style0 from "./ObraPageView.vue?vue&type=style&index=0&id=69ccd318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ccd318",
  null
  
)

export default component.exports